import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
} from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import {
  ITrackingAction,
  ITrackingObject,
} from '../../../tracking/tracking.data';
import { CustomFormFieldComponent } from '../custom-form-field/custom-form-field.component';

@Component({
  selector: 'app-email-tag-field',
  templateUrl: './email-tag-field.component.html',
  styleUrls: ['./email-tag-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EmailTagFieldComponent),
      multi: true,
    },
  ],
})
export class EmailTagFieldComponent
  extends CustomFormFieldComponent
  implements ControlValueAccessor {
  @Input() label: string;
  @Input() hideLabel: boolean;
  @Input() fieldId: string;
  @Input() focusableTrigger$: Observable<any>;
  @Input() limit: number;
  @Input() maxRecipientsMessage: string;
  @Input() trackingObject: ITrackingObject;
  @Input() trackingAction: ITrackingAction;

  @Output() onFocus: EventEmitter<void> = new EventEmitter<void>();
  @Output() onBlur: EventEmitter<void> = new EventEmitter<void>();

  formControl: AbstractControl;
  hasMaxRecipients: boolean;

  constructor(
    protected changeDetectorRef: ChangeDetectorRef,
    translateService: TranslateService
  ) {
    super(changeDetectorRef, translateService);
  }

  writeValue(value: any) {
    if (!this.formControl) {
      this.formControl = new FormControl(value);
    }
  }

  valueUpdated(values: string) {
    this.propagateChange(values);
    if (values.trim() === '' || values.split(',').length < this.limit) {
      this.hasMaxRecipients = false;
    }
  }

  onHitMaxTags(didHitMaxTags: boolean) {
    this.hasMaxRecipients = didHitMaxTags;
  }

  onInputBlur() {
    this.hasMaxRecipients = false;
    this.onBlur.emit();
  }
}
